export default __webpack_public_path__ + "static/characters_01_Aury_HP0-692b7898fa93c8514b808f277b9c72c1.png";